/**
 * effects.jsx
 * -----------
 * Small celebratory effects used by lessons.
 *
 * Export
 * - confetti(svgEl, overlay, count?)
 * - burstConfettiAt(hostEl, {x,y}, count?)
 * - bullPopAt(hostEl, {x,y}, emoji?)
 */

export function confetti(container, size, count = 28) {
  if (!container || !(container instanceof Element) || !container.parentElement) return;
  const host = container.parentElement;
  const colors = ["#FF7C24", "#2ECC71", "#FFB800", "#FFFFFF"];
  const cx = (size?.w ?? 0) / 2;
  for (let i = 0; i < count; i++) {
    const el = document.createElement("div");
    el.className = "confetti";
    el.style.left = `${cx + (Math.random() * 120 - 60)}px`;
    el.style.top = `24px`;
    el.style.background = colors[i % colors.length];
    el.style.transform = `rotate(${Math.random() * 180}deg)`;
    el.style.zIndex = "30";
    host.appendChild(el);
    setTimeout(() => el.remove(), 1000);
  }
}

export function burstConfettiAt(hostEl, origin, count = 40) {
  if (!hostEl || !origin) return;
  const colors = ["#FF7C24", "#FFD166", "#2ECC71", "#00D1FF", "#FFFFFF"];
  for (let i = 0; i < count; i++) {
    const el = document.createElement("div");
    el.className = "confetti";
    el.style.left = `${origin.x}px`;
    el.style.top = `${origin.y}px`;
    el.style.background = colors[i % colors.length];
    el.style.zIndex = "30";
    const angle = Math.random() * Math.PI * 2;
    const speed = 120 + Math.random() * 160;
    const dx = Math.cos(angle) * speed;
    const dy = Math.sin(angle) * speed * 0.85;
    el.style.setProperty("--dx", `${dx}px`);
    el.style.setProperty("--dy", `${dy}px`);
    el.style.setProperty("--rot", `${(Math.random() * 360) | 0}deg`);
    hostEl.appendChild(el);
    setTimeout(() => el.remove(), 1000);
  }
}

export function bullPopAt(hostEl, origin, emoji = "🐂") {
  if (!hostEl || !origin) return;
  const el = document.createElement("div");
  el.className = "fx-bull";
  el.style.left = `${origin.x}px`;
  el.style.top = `${origin.y}px`;
  el.style.transform = "translate(-50%, -50%)";
  el.style.zIndex = "31";
  el.textContent = emoji;
  hostEl.appendChild(el);
  setTimeout(() => el.remove(), 900);
}
